export const AUTO_TEXTS = [
  'Warm',
  'Reliable',
  'Comforting',
  'Inclusive',
  'Thoughtful',
  'Positive',
  'Trustworthy',
];

export const LINEAR_GRADIENT_TEXTS = [
  '안녕하세요 \n락앤락입니다.',
  '您好，\n这里是乐扣乐扣。',
  'こんにちは、\nロックンロックです。',
  'Hello, \nthis is LocknLock.',
];

export const INTRODUCTIONS = [
  {
    title: '높은 안정성으로\n신뢰를 전합니다.',
    description:
      '모든 제품과 서비스에서 고객에게\n신뢰와 안전을 깊이 있게 제공하는 것을\n목표로 합니다.',
  },
  {
    title: '불편을 해결해\n편안함을 제공합니다.',
    description:
      '주방에서부터 일상의 모든 순간까지,\n안정감을 느낄 수 있도록 그들의\n삶을 보호하고 신뢰를 쌓아갑니다.',
  },
  {
    title: '변함없는 지속성으로\n불안을 해결합니다.',
    description:
      '변함없는 지속성을 통해 일상에서\n마주하는 불안감을 해결하고,\n언제나 마음의 평안을 제공합니다.',
  },
];
